export default __webpack_public_path__ + "static/media/m.6e777a17.jpg";